var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27143 10.0487L6.09132 6.22877C6.34842 5.97167 6.49286 5.62297 6.49286 5.25938C6.49286 4.89578 6.34842 4.54708 6.09132 4.28998L2.27143 0.470089C1.64464 -0.156696 0.626786 -0.156696 0 0.470089L4.78929 5.25938L0 10.0487C0.626786 10.6754 1.64464 10.6754 2.27143 10.0487Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.994b21dc90cc53be179132eddf583e9e.svg";
export { ForwardRef as ReactComponent };